import _ from "lodash";
import { useEffect, useState } from "react";
import DataTable from "examples/Tables/DataTable";
import InvoicesActionCell from "components/CustomCells/InvoicesActionCell";
import ToastUtils from "utils/ToastUtils";
import ApiService from "services/ApiService";
import Helpers from "utils/Helpers";
import TableStatusCell from "components/CustomCells/TableStatusCell";
import TableActionCell from "components/CustomCells/TableActionCell";

function TablesTable({ companyId = null, fromDate = null, toDate = null }) {
  const [invoices, setTables] = useState([]);

  const columns = [
    { Header: "ID", accessor: "id", width: "5%" },
    { Header: "ΤΡΑΠΕΖΙ", accessor: "name" },
    { Header: "ΚΑΤΑΣΤΑΣΗ", accessor: "status" },
    { Header: "ΥΠΟΛΟΙΠΟ", accessor: "amountToPay", width: "10%" },
    { Header: "ΕΚΚΙΝΗΣΗ", accessor: "createdAt", width: "10%" },
    { Header: "ΟΛΟΚΛΗΡΩΣΗ", accessor: "closedAt", width: "10%" },
    { Header: "ΕΝΕΡΓΕΙΕΣ", accessor: "actions" },
  ];

  const refreshTables = async () => {
    const url = `/api/v1/open-tables/all?companyId=${companyId}&issueDateFrom=${Helpers.formatDateToInvoice(
      fromDate
    )}&issueDateTo=${Helpers.formatDateToInvoice(toDate)}`;

    const response = await ApiService.getData(url);

    if (!response) {
      ToastUtils.error("Αδυναμία αναζήτησης τραπεζιών!");
      return;
    }

    ToastUtils.success("Επιτυχής αναζήτηση τραπεζιών!");
    const invoices = response.data.data;
    invoices.map((e) => {
      e.status = <TableStatusCell status={e.closedAt} />;
      e.actions = <TableActionCell invoice={e} />;

      const createdAt = new Date(e.createdAt);
      const closedAt = new Date(e.closedAt);
      e.createdAt = createdAt
        .toLocaleString("en-GB", { timeZone: "Europe/Athens" })
        .replace(",", "");
      e.closedAt = closedAt.toLocaleString("en-GB", { timeZone: "Europe/Athens" }).replace(",", "");
    });
    setTables(response.data.data);
  };

  useEffect(() => {
    if (!companyId || !fromDate || !toDate) return;
    refreshTables();
  }, [companyId, fromDate, toDate]);

  return (
    <DataTable
      table={{ rows: invoices, columns: columns }}
      entriesPerPage={{
        defaultValue: 10,
        entries: [10, 20, 50],
      }}
      canSearch
    />
  );
}

export default TablesTable;
